import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["componentName", "_contextual", "ModalDialog", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "Transition", "rootNode"];
import PropTypes from 'prop-types';
import { useContext } from 'react';
// @ts-expect-error convert to TS
import { makeEventRelay } from '../../core/EventRelay';
import memoizeOne from 'react-utils/memoizeOne';
import UIModalDialog from '../UIModalDialog';
import UIFullScreen from '../UIFullScreen';
// @ts-expect-error convert to TS
import getTransitionProps from './getTransitionProps';
import { SandboxContext } from '../../context/SandboxContext';
import { asHiddenProp } from '../../utils/asHiddenProp';
import { useFoundationsReadinessTracking } from '../../utils/useFoundationsReadinessTracking';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AbstractModal(_ref) {
  let {
      componentName,
      _contextual,
      ModalDialog = AbstractModal.defaultProps.ModalDialog,
      onOpenStart,
      onOpenComplete,
      onCloseStart,
      onCloseComplete,
      Transition,
      rootNode
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const sandboxedContext = useContext(SandboxContext).sandboxed;
  const sandboxed = _contextual || sandboxedContext;
  const closeStartRelay = makeEventRelay();
  const openCompleteRelay = makeEventRelay();
  const memoizedGetTransitionProps = memoizeOne(getTransitionProps);
  const renderedModalDialog = /*#__PURE__*/_jsx(ModalDialog, Object.assign({}, rest, {
    contextual: _contextual === undefined ? _contextual : asHiddenProp(_contextual),
    _openCompleteRelay: sandboxed ? null : openCompleteRelay,
    _closeStartRelay: sandboxed ? null : closeStartRelay
  }));
  useFoundationsReadinessTracking();
  return sandboxed ? renderedModalDialog : /*#__PURE__*/_jsx(UIFullScreen, {
    "data-layer-for": componentName,
    rootNode: rootNode,
    Transition: Transition
    // @ts-expect-error UIFullScreen spreads transitionProps into UILayer
    ,
    transitionProps: memoizedGetTransitionProps(onOpenStart, openCompleteRelay.getHandle(onOpenComplete), closeStartRelay.getHandle(onCloseStart), onCloseComplete),
    children: renderedModalDialog
  });
}
AbstractModal.propTypes = {
  componentName: PropTypes.string.isRequired,
  _contextual: PropTypes.bool,
  ModalDialog: PropTypes.elementType.isRequired,
  onOpenStart: PropTypes.func,
  onOpenComplete: PropTypes.func,
  onCloseStart: PropTypes.func,
  onCloseComplete: PropTypes.func,
  rootNode: UIFullScreen.propTypes.rootNode,
  Transition: PropTypes.elementType
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
AbstractModal.defaultProps = {
  ModalDialog: UIModalDialog
};
AbstractModal.displayName = 'AbstractModal';